import type { Page } from '@ps/web-core-store';
import React from 'react';

import CMSReferences from '../CMSReference/CMSReferences';

import PageBody from './PageBody/PageBody';

const CMSPage: React.FC<Page> = ({ content, template, theme }) => {
  const twoColumns = template === '2 Column';
  const darkTheme = theme === 'Dark';
  const [{ seo, top, side, main }] = content;

  return (
    <>
      <CMSReferences references={seo} />
      <CMSReferences references={top} />
      <PageBody side={side} main={main} twoColumns={twoColumns} darkTheme={darkTheme} />
    </>
  );
};

export default CMSPage;
